<template>
  <div 
    v-if="showShareMask || payStatus" 
    :class="(payStatus || showShareMask) ? (isLovePage ? 'love-glass-effect' : 'glass-effect') : ''" 
  >
    <div v-if="showShareMask" >
      <van-button round color="linear-gradient(to bottom, #7232dd, #ceb6dc)" @click="showGuideDialog = true">
        开始分享<van-icon name="share" />
      </van-button>
      <p>点击按钮开始分享，{{ TipDesc ? TipDesc : '即可解锁全部印占分盘、命格、运势信息' }} </p>

      <van-dialog
        v-model="showGuideDialog"
        title="如何分享解锁"
        show-cancel-button
        confirm-button-text="我知道了"
        :get-container="getContainer"
        @close="onGuideDialogClose"
        @confirm="onGuideDialogClose"
        @cancel="onGuideDialogClose"
      >
        <div class="share-guide-dialog-text">
          <p>请点击微信右上角菜单 <span style="color:#1989fa;">“···”</span></p>
          <p>选择 <span style="color:#1989fa;">【转发给朋友】</span> 进行分享，</p>
          <p>{{ TipDesc ? TipDesc : '即可解锁全部印占分盘、命格、运势信息' }} </p>
        </div>
      </van-dialog>
    </div>
    <div v-else>
      <van-button
        round
        color="linear-gradient(to bottom, #7232dd, #ceb6dc)"
        @click="onUnlockClick"
      >
        点击解锁<van-icon name="lock" />
      </van-button>
      <p style="margin-top: 20px; font-weight: bold;">
        点击上方按钮解锁，{{ TipDesc ? TipDesc : '全部印占分盘、命格、运势信息' }} 
      </p>
    </div>
  </div>
</template>

<script>
import wxChatMixin from "@/mixin/wxChat";
// 如未全局注册 van-dialog, 可引入 import { Dialog } from 'vant';

export default {
  name: 'RowTitle',
  mixins: [wxChatMixin],
  props: {
    order_id: {
      type: String,
    },
    typeDescription: {
      type: String,
      default: '本名盘',
    },
    TipDesc: {
      type: String,
    },
    isLovePage: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      payStatus: false,
      showShareMask: false,
      showGuideDialog: false,
      orderPrice: 0,
      // paid = 1, 支付成功
      // paid = 2, 旧数据库中不显示到前端，前端不需要改成这个，为历史遗留内容
      // paid = 3, 标记订单已删除（用户手动删除）
      // Paid = 4, 创建订单，未支付.（可以显示基础信息）
    };
  },

  mounted () {
    const order_id = this.$route.params.order_id;
    this.$api.getOrderBirth({order_id: order_id}).then(res => { 
      this.payStatus = res.data.content.paid === 4? true : false;
      this.orderPrice = res.data.content.pay_price;
      this.showShareMask = !this.payStatus && res.data.content.share == 0 ? true : false;
    })
  },

  methods: {
    getContainer() {
      return document.querySelector('#app');
    },
    // 关闭引导弹框时，触发分享设置
    onGuideDialogClose() {
      this.showGuideDialog = false;
      this.initWechatShare();
    },
    // 支付函数授权
    signPayInterface () {
      const order_sn = this.order_id;
      const typeDescription = this.typeDescription;
      const _this = this;
      const signUrl = location.href.split('#')[0];
      this.wxInterfaceCall(signUrl, ['checkJsApi', 'chooseWXPay'], wx => {
        wx.checkJsApi({
          jsApiList: ['chooseWXPay'],
          success: async (res) => {
            if (!res.checkResult.chooseWXPay) {
              _this.$dialog.alert({
                title: "错误",
                message: "微信版本不支持"
              })
              return false;
            }

            let result = await _this.$api.postPrepay_id({
              description: typeDescription,
              out_trade_no: order_sn,
              openid: sessionStorage.getItem("openid")
            })
            let payConfing = result.data ? result.data : {};
            if (payConfing.errorCode != 0) {
              return _this.$toast.fail(payConfing.text)
            }
            let wxPayConfing = payConfing.content;
            _this.callWxPay(_this, wx, wxPayConfing, order_sn)
          }
        });

      });
    },

    // 调起微信支付
    callWxPay (content, wx, wxPayConfing, order_sn, currentProduct) {
      let _this = content;
      wx.chooseWXPay({
        timestamp: wxPayConfing.timeStamp,
        nonceStr: wxPayConfing.nonceStr,
        package: wxPayConfing.package,
        signType: "RSA",
        paySign: wxPayConfing.paySign,
        success: (payRes) => {
          console.log("支付成功回调::::", payRes)
          // 支付成功后的回调函数
          if (payRes.errMsg == "chooseWXPay:ok") {
              _this.$api.setOrderStatus({
                order_id: order_sn,
                paid: 1,
                share: 1,
              }).then(setResult => {
                  if (setResult.data.errorCode != 0) {
                    return this.$toast(setResult.data.text);
                  }
                  window.location.reload();
              })
              _this.$emit('payStatus', true)
          }
        },
        fail: (err) => {
          console.log("支付失败回调::::", err)
          _this.$toast("支付业务繁忙，稍后重试！");
        },
        cancel: function () {
          // 用户取消支付
          _this.$dialog.confirm({
            showCancelButton: true,
            title: "要放弃支付吗",
            message: "您要放弃导出自己的星盘吗？",
            confirmButtonText: "立即占星",
            cancelButtonText: "忍痛离开",
            cancelButtonColor: "#a6aabf"
          }).then(() =>{
            _this.callWxPay(content, wx, wxPayConfing, order_sn, currentProduct)
            // _this.callWxPay(_this.order_id, _this.currentProduct)
          }).catch(() => {
            _this.$toast("您取消了支付！");
          });
        },
      });
    },

    // 点击“点击解锁”按钮后的确认弹框
    onUnlockClick () {
      this.$dialog.confirm({
        title: '支付确认',
        message: `${this.orderPrice}元获取全部解读，无二次付费~`,
        confirmButtonText: '确认支付',
        cancelButtonText: '再想想',
        cancelButtonColor: '#a6aabf'
      })
        .then(() => {
          this.signPayInterface();
        })
        .catch(() => {
          // 用户取消，无需处理
        });
    },

    async shareTest() {
      if (!this.order_id) {
        return this.$toast('请先选择服务');
      }
      
      // 获取当前产品信息
      let currentProduct = {
        name: '占星服务',
        product_id: 1 // 根据实际情况调整
      };
      this.signPayInterface(this.order_id, currentProduct)
    },
    
    async initWechatShare () {
      if (!/micromessenger/i.test(navigator.userAgent)) {
        console.log('非微信环境');
        return;
      }
      let _this = this;
      let signUrl = location.href.split('#')[0];
      this.wxInterfaceCall(signUrl, ['updateAppMessageShareData', 'onMenuShareAppMessage'], wx => {
        wx.updateAppMessageShareData({
          title: '印占H5',
          desc: '一起来占星，发现你的幸运星盘！',
          link: window.location.origin,
          // imgUrl: 'https://example.com/logo.png',
          success: _this.handleShareSuccess
        });
        wx.onMenuShareAppMessage({
          title: '印占H5',
          desc: '一起来占星，发现你的幸运星盘！',
          link: window.location.origin,
          // imgUrl: 'https://example.com/logo.png',
          success: _this.handleShareSuccess
        });
      });
    },

    // 分享成功回调
    handleShareSuccess () {
      // 在这里可以处理成功后的业务逻辑，比如更新订单状态
      this.$api.setOrderStatus({
        order_id: this.order_id,
        paid: 1,
        share: 1,
      }).then(() => {
        window.location.reload();
      });
    },
  }
}
</script>

<style lang="less" scoped>
.glass-effect {
  position: absolute;
  width: 100%;
  padding: 100px 25px;
  height: calc(100% - 100px - 50px);
  min-height: 100px;
  bottom: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.85); /* 提高不透明度，保证IOS微信星标失效时的兜底效果 */
  /* 仍然保留高斯模糊，但用渐进增强思路 */
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 15px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  z-index: 2;
  /* iOS 微信星标内 backdrop-filter 失效时用 background 模拟半透明 */
}

.love-glass-effect {
  position: absolute;
  width: 100%;
  padding: 100px 25px;
  height: calc(100% - 100px - 250px);
  bottom: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.85); /* 提高不透明度，兜底兼容 */
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 15px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  z-index: 2;
}

/* 针对ios微信星标特殊处理，判断环境加class, 也可以配合js检测加上.no-blur类*/
.no-blur .glass-effect,
.no-blur .love-glass-effect {
  /* 彻底兜底: 无高斯模糊，直接更为实色背景 */
  background: rgb(255,255,255);
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}


/* 弹框的文本 */
.share-guide-dialog-text {
  color: #333;
  line-height: 1.7;
  text-align: center;
  margin-bottom: 8px;
}
</style>
